import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "popTitle" }
const _hoisted_2 = { class: "popList" }
const _hoisted_3 = { class: "popNow" }

import i18n from "@/language";
import { computed, ref, toRefs, watch } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'LangPopup',
  props: {
    show: { type: Boolean }
  },
  emits: ["update:show"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emits = __emit;
const { show } = toRefs(props);
const newShow = ref(show.value);
const currentLang = ref('English')

const getNowLang = () => {
  let lang = localStorage.getItem("lang")
  let nowLang = "English"
  switch (lang) {
    case "zh":
      nowLang = "中文"
      break;
    case "en":
      nowLang = "English"
      break;
    case "ms":
      nowLang = "Bahasa Malaysia"
      break;
    case "es":
      nowLang = "Español"
      break;
    default:
      nowLang = "English"
      break;
  }
  currentLang.value = nowLang
}

const handleChoose = (lang: "zh" | "en" | "es" | "ms") => {
  i18n.global.locale = lang;
  localStorage.setItem("lang", lang)
  emits('update:show', false)
}

watch(show, () => {
  if (newShow.value != show?.value) {
    newShow.value = show?.value;
  }
  if (show?.value) {
    getNowLang()
  }

});



return (_ctx: any,_cache: any) => {
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createBlock(_component_van_popup, {
    show: newShow.value,
    "onUpdate:show": _cache[4] || (_cache[4] = ($event: any) => ((newShow).value = $event)),
    class: "popup",
    position: "bottom",
    onClose: _cache[5] || (_cache[5] = ($event: any) => (emits('update:show', false)))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", null, _toDisplayString(_ctx.$t('选择语言')), 1)
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('当前语言')) + ":", 1),
          _createTextVNode(" " + _toDisplayString(currentLang.value), 1)
        ]),
        _createElementVNode("div", {
          class: "popItem",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (handleChoose('zh')))
        }, [
          _cache[6] || (_cache[6] = _createElementVNode("span", null, "中文", -1)),
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('中文')), 1)
        ]),
        _createElementVNode("div", {
          class: "popItem",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (handleChoose('en')))
        }, [
          _cache[7] || (_cache[7] = _createElementVNode("span", null, "English", -1)),
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('英语')), 1)
        ]),
        _createElementVNode("div", {
          class: "popItem",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (handleChoose('ms')))
        }, [
          _cache[8] || (_cache[8] = _createElementVNode("span", null, "Bahasa Malaysia", -1)),
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('马来西亚语')), 1)
        ]),
        _createElementVNode("div", {
          class: "popItem",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (handleChoose('es')))
        }, [
          _cache[9] || (_cache[9] = _createElementVNode("span", null, "Español", -1)),
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('西班牙语')), 1)
        ])
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})